var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWebLogoNb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 62.15 54.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-4{fill:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{fill:url(#linear-gradient-8);}.cls-9{fill:url(#linear-gradient-9);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -186.97,
    y1: -986.55,
    x2: -147.67,
    y2: -986.55,
    gradientTransform: "translate(-748.48 659.11) rotate(60)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0091d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d3979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -135.57,
    y1: -968.13,
    x2: -156.04,
    y2: -1000.47,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -145.89,
    y1: -1020.68,
    x2: -164.61,
    y2: -986.49,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 1887.81,
    y1: 1402.21,
    x2: 1869.16,
    y2: 1435.25,
    gradientTransform: "translate(1923.62 1459.52) rotate(180)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -186.97,
    y1: -986.55,
    x2: -147.67,
    y2: -986.55,
    gradientTransform: "translate(-748.48 659.11) rotate(60)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0091d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#008ed0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#0283c5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#0572b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#08599a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.99,
    stopColor: "#0d3a7a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d3979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -160.23,
    y1: -1020.65,
    x2: -178.95,
    y2: -987.47,
    gradientTransform: "translate(-748.48 659.11) rotate(60)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0091d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#018dcf"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0281c2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#056cae"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#0a5091"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d3979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 2989.1,
    y1: -1565.03,
    x2: 2970.19,
    y2: -1531.53,
    gradientTransform: "translate(-134.67 3387.88) rotate(-60)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0091d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#0476b7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0d3979"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -136.07,
    y1: -967.8,
    x2: -156.55,
    y2: -1000.15,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -145.63,
    y1: -1020.53,
    x2: -164.34,
    y2: -986.35,
    gradientTransform: "translate(-748.48 659.11) rotate(60)",
    xlinkHref: "#linear-gradient-7"
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "WebLogo NB") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M42.74,57.05,46,51.39l-6.64-4.07L26.44,24.91c-3.68-6.1-2.79-7.78.64-7.78H19.7A3.89,3.89,0,0,0,16.33,23L36,57.05a3.89,3.89,0,0,0,6.74,0Z",
    transform: "translate(-0.8 -4.11)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.26,44,54.93,10a3.9,3.9,0,0,0-3.37-5.84H45l-.19,7.78L31.89,34.31c-3.45,6.23-5.35,6.3-7.06,3.34L28.52,44a3.89,3.89,0,0,0,6.74,0Z",
    transform: "translate(-0.8 -4.11)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M47.42,22.94a3.9,3.9,0,0,0-3.37-5.84H12l0,0c-3.42,0-4.31,1.68-.64,7.77H37.31c7.12-.14,8.13,1.47,6.42,4.44Z",
    transform: "translate(-0.8 -4.11)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M39.39,59a3.89,3.89,0,0,0,3.37-1.94L62.44,23a3.9,3.9,0,0,0-3.37-5.84H52.52l-.19,7.78L39.39,47.31c-3.44,6.25-5.34,6.31-7.06,3.35L36,57.05A3.9,3.9,0,0,0,39.39,59Z",
    transform: "translate(-0.8 -4.11)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M35.23,44l3.28-5.67-6.64-4.06L18.93,11.91c-3.68-6.1-2.79-7.78.64-7.78H12.19A3.89,3.89,0,0,0,8.82,10L28.5,44a3.88,3.88,0,0,0,6.73,0Z",
    transform: "translate(-0.8 -4.11)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M19.57,4.13c-3.43,0-4.31,1.68-.64,7.77H44.8c7.12-.13,8.13,1.48,6.42,4.45L54.91,10a3.9,3.9,0,0,0-3.37-5.84h-32Z",
    transform: "translate(-0.8 -4.11)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M1.32,19.07a3.91,3.91,0,0,0,0,3.89L21,57.05a3.9,3.9,0,0,0,6.74,0L31,51.38l-6.64-4.07L11.44,24.9c-3.68-6.1-2.79-7.78.63-7.78H4.69A3.9,3.9,0,0,0,1.32,19.07Z",
    transform: "translate(-0.8 -4.11)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M27.76,57,47.43,23a3.9,3.9,0,0,0-3.37-5.84H37.52l-.2,7.79L24.39,47.31c-3.44,6.24-5.34,6.31-7.06,3.34L21,57a3.89,3.89,0,0,0,6.74,0Z",
    transform: "translate(-0.8 -4.11)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M62.42,23a3.9,3.9,0,0,0-3.37-5.84l-37.12,0,4.5,7.77H52.31c7.12-.14,8.13,1.47,6.42,4.44Z",
    transform: "translate(-0.8 -4.11)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebLogoNb);
export default __webpack_public_path__ + "static/media/WebLogo NB.779dbc267eb5a27d9b9da3006631ed20.svg";
export { ForwardRef as ReactComponent };